import { render } from "./popover.html?vue&type=template&id=29c95e4e&scoped=true&ts=true&external"
import script from "./popover.ts?vue&type=script&lang=ts&external"
export * from "./popover.ts?vue&type=script&lang=ts&external"

import "./popover.scss?vue&type=style&index=0&id=29c95e4e&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c95e4e"]])

export default __exports__